import Vue from 'vue'
import { Table, Form, Button, Icon, Row, Col, Input, Modal } from 'ant-design-vue'
import SliderCaptcha from '@/components/slider-captcha'
import VerificationCode from '@/components/verification-code'
import MobileInput from '@/components/mobile-input'
import UserIcon from '@/components/icon'

import './css/index.less'

Vue.use(Table)
Vue.use(Form)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Input)
Vue.use(UserIcon)
Vue.use(Row)
Vue.use(Col)
Vue.use(SliderCaptcha)
Vue.use(VerificationCode)
Vue.use(Modal)
Vue.use(MobileInput)
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$success = Modal.success
Vue.prototype.$error = Modal.error
